export class ExpandableInfoBlock {
  constructor(element) {
    this.element = element;
    this.items = element.querySelectorAll('.js-default-hidden');
    this.trigger = element.querySelector('.js-block-trigger');
    this.stateWord = this.trigger.dataset.stateWord

    if (this.trigger && this.items) {
      this.init();
    }
  }

  init() {
    this.trigger.addEventListener('click', () => this.toggle());
  }

  toggle() {
    const {open} = this.element.dataset;

    if (open === 'true') {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.element.dataset.open = 'true';
    [...this.items].forEach(item => item.classList.add('opened'));

    if (this.stateWord && this.stateWord === 'meer') {
      this.trigger.innerText = this.trigger.innerText.replace(this.stateWord, 'minder');
      this.stateWord = 'minder';
      this.trigger.classList.add('button-link-toggle--active');
    }
  }

  close() {
    this.element.dataset.open = 'false';
    [...this.items].forEach(item => item.classList.remove('opened'));

    if (this.stateWord && this.stateWord === 'minder') {
      this.trigger.innerText = this.trigger.innerText.replace(this.stateWord, 'meer');
      this.stateWord = 'meer';
      this.trigger.classList.remove('button-link-toggle--active');
    }
  }
}